import React, {
  createContext,
  useState,
  useContext,
  useEffect,
  useRef,
} from 'react';
import { useNavigate } from 'react-router-dom';
import { GraphQLClientContext, useAxiosClient } from './GraphQLClientContext ';
import { GET_SCREEN_INFO } from '../graphql/queries/onboardingQueries';

import { toast } from 'react-toastify';
import { getErrMsgFromResp } from '../utils/errorHandler';
import { UPDATE_ID_PROOFS } from '../graphql/mutations/onboardingmutations';
import Cookies from 'universal-cookie';
import { logger } from '../utils/logger';

const OnboardingContext = createContext();

export const OnboardingProvider = ({ children }) => {
  const cookies = new Cookies();

  const navigate = useNavigate();
  const client = useContext(GraphQLClientContext);
  // value can be landing review and component
  const [currScreen, setCurrScreen] = useState('landing');
  const [loading, setLoading] = useState(false);
  const [editingMode, setEditingMode] = useState(false);
  const [isBackClick, setIsBackClick] = useState(false);
  const [error, setError] = useState(null);
  const [totalSteps, setTotalSteps] = useState(0);
  const [activeCat, setActiveCat] = useState('');
  const [isOnboardingDone, setIsOnboardingDone] = useState(false);
  const [prevPage, setPrevPage] = useState('');
  const [detailsFlow, setDetailsFlow] = useState([]);
  const [stepsInfo, setStepsInfo] = useState({
    component: '',
    order: 0,
    stepId: 0,
    skip: false,
    desc: '',
    totalSteps: 0,
    finished: false,
  });
  const [currStep, setCurrStep] = useState({
    component: '',
    order: 0,
    stepId: 0,
    skip: false,
    desc: '',
    totalSteps: 0,
    finished: false,
  });

  const handleSteps = (step) => {
    logger.log('i am handling step', step);
    toast.dismiss();
    if (typeof step === 'number') {
      if (step <= 0 || step > detailsFlow.length) {
        logger.log('Steps out of range');
      } else {
        const stpsarr = detailsFlow.find((item) => item.order === step);
        setStepsInfo({
          ...stpsarr,
          totalSteps: totalSteps,
          finished: false,
        });
      }
    } else if (typeof step === 'string') {
      const stpsarr = detailsFlow.find((item) => item.component === step);
      logger.log('kyc', step);
      setStepsInfo({
        ...stpsarr,
        totalSteps: totalSteps,
        finished: false,
      });
      if (activeCat === 'basic_details') {
        // setEditingMode(true);
      } else if (activeCat === 'kyc') {
        setCurrScreen('');
        if (step === 'ReviewKYCDetails') {
          setCurrScreen('review');
        }
      } else {
        setEditingMode(false);
      }
    }
  };

  const fetchScreenDetails = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    try {
      setLoading(true);
      setError(null);
      logger.log('client', client);

      const data = await client.request(GET_SCREEN_INFO, {});
      logger.log('onboardingdata', data);
      const requestID = urlParams.get('requestId');
      if (requestID) {
        setCurrScreen('component');
      }
      if (data.screens) {
        const screenDetails = data.screens;
        let cat, subcat;

        // if (isAadharpresent) {
        //   cat = 'kyc';
        //   subcat = 'ReviewKYCDetails';
        //   screenDetails.activeCategory = 'kyc';
        //   screenDetails.activeSubCategory = 'ReviewKYCDetails';
        //   setCurrScreen('review');
        // } else {
        //   cat = screenDetails.activeCategory;
        //   subcat = screenDetails.activeSubCategory;
        // }
        cat = screenDetails.activeCategory;
        subcat = screenDetails.activeSubCategory;
        const arr = cat
          ? screenDetails.screens[`${cat.toLowerCase()}`] || []
          : [];

        logger.log('activecat', cat);
        if (!cat) {
          logger.log('activeCategory is null - onboarding complete');
          setActiveCat('kyc');
          setIsOnboardingDone(true);
          setCurrScreen('review');
        } else if (cat !== 'kyc' && cat !== 'basic_details') {
          logger.log('in this kyc');
          setActiveCat('kyc');
          setIsOnboardingDone(true);
          setCurrScreen('review');
          // setSubCat('ReviewKYCDetails');
        } else {
          setActiveCat(cat);
        }

        setDetailsFlow(arr);
        const totalstep = arr.length;
        setTotalSteps(totalstep);
        const filter = arr.filter((item) => subcat === item.component);
        setStepsInfo({
          ...(filter[0] || {}),
          totalSteps: totalstep,
          finished: false,
        });
        setCurrStep({
          ...(filter[0] || {}),
          totalSteps: totalstep,
          finished: false,
        });
      }
    } catch (err) {
      setError(getErrMsgFromResp(err));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchScreenDetails();
  }, [stepsInfo.finished]);

  useEffect(() => {
    if (activeCat === 'kyc') {
      var step2 = document.getElementById('step2');
      step2.className = 'step completed';
      var step3 = document.getElementById('step3');
      if (isOnboardingDone) {
        step3.className = 'step completed';
      } else {
        step3.className = 'step inprogress';
      }
    }
  }, [activeCat, isOnboardingDone]);

  const handleNextButton = () => {
    const newStepNo = stepsInfo.order + 1;
    setIsBackClick(false);
    return handleSteps(newStepNo);
  };

  const backButtonRef = useRef(() => {
    const newStepNo = stepsInfo.order - 1;
    return handleSteps(newStepNo);
  });

  return (
    <OnboardingContext.Provider
      value={{
        client,
        currScreen,
        setCurrScreen,
        loading,
        setLoading,
        editingMode,
        setEditingMode,
        isBackClick,
        setIsBackClick,
        error,
        setError,
        totalSteps,
        setTotalSteps,
        activeCat,
        setActiveCat,
        prevPage,
        setPrevPage,
        detailsFlow,
        setDetailsFlow,
        stepsInfo,
        setStepsInfo,
        currStep,
        setCurrStep,
        handleSteps,
        handleNextButton,
        backButtonRef,
        fetchScreenDetails,
        isOnboardingDone,
        setIsOnboardingDone,
      }}
    >
      {children}
    </OnboardingContext.Provider>
  );
};

export const useOnboarding = () => {
  const context = useContext(OnboardingContext);
  if (!context) {
    throw new Error('useOnboarding must be used within an OnboardingProvider');
  }
  return context;
};
